import { render, staticRenderFns } from "./MultipleCustomer.vue?vue&type=template&id=4cb98a65&"
import script from "./MultipleCustomer.vue?vue&type=script&lang=js&"
export * from "./MultipleCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports